import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { faDash } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCircleStar } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import {
  faCircleArrowDown,
  faCircleArrowUp,
} from '@soundxyz/font-awesome/sharp-solid-svg-icons/index.mjs';
import { theme } from '@components-shared/src/stitches';
import { useChartCardContext } from './Context';

export const CHANGE_TYPES = {
  UP: 'UP',
  DOWN: 'DOWN',
  SAME: 'SAME',
  NEW: 'NEW',
} as const;

function ChangeIndicator({ type }: { type: keyof typeof CHANGE_TYPES }) {
  if (type === CHANGE_TYPES.UP) {
    return (
      <FontAwesomeIcon icon={faCircleArrowUp} size="xs" color={theme.colors.brand300.toString()} />
    );
  }

  if (type === CHANGE_TYPES.DOWN) {
    return (
      <FontAwesomeIcon
        icon={faCircleArrowDown}
        size="xs"
        color={theme.colors.destructive300.toString()}
      />
    );
  }

  if (type === CHANGE_TYPES.NEW) {
    return (
      <FontAwesomeIcon icon={faCircleStar} size="xs" color={theme.colors.warning400.toString()} />
    );
  }

  return <FontAwesomeIcon icon={faDash} size="xs" color={theme.colors.base400.toString()} />;
}

export function ChartCardRank({
  rank,
  change,
}: {
  /**
   * Current rank in chart
   */
  rank: number;
  /**
   * Name of the release can go here. React node so that we can pass buttons, links etc.
   */
  change: keyof typeof CHANGE_TYPES;
}) {
  const { isLoadingSummary, minimal } = useChartCardContext();

  return (
    <div
      className={clsx(
        'absolute left-0 top-0 h-10 w-7 flex-shrink-0 flex-col justify-center gap-1 overflow-hidden rounded-br-md bg-black bg-opacity-90',
        isLoadingSummary ? 'hidden' : 'flex',
        !minimal && 'h-10 w-7 md:h-14 md:w-12',
      )}
    >
      <div
        className={clsx(
          'w-full text-center font-title text-title-xs font-medium leading-3 text-white',
          !minimal && 'md:text-title-m md:leading-5',
        )}
      >
        {rank}
      </div>
      <ChangeIndicator type={change} />
    </div>
  );
}
